import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { faCheck } from '@fortawesome/pro-solid-svg-icons';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { PermissionProfile } from '../../../core/enums/generated/PermissionProfile';
import { SecurityService } from '../../../core/security/security.service';
import { PermissionVm } from '../../../shared/generated/Administration/Models/Security/Permissions/PermissionVm';
import { EditUserService } from '../../../users/edit-user/edit-user.service';

@Component({
    selector: 'pcg-user-permissions-modal',
    templateUrl: './user-permissions-modal.component.html',
    styleUrls: ['./user-permissions-modal.component.scss'],
    standalone: false
})
export class UserPermissionsModalComponent implements OnInit {

	permissions: PermissionVm[];
	formGroup: UntypedFormGroup = PermissionVm.Form;
	model = PermissionVm.GetModel(this.formGroup);
	faCheck = faCheck;
	isSysAdmin: boolean;

	constructor(
		public activeModal: NgbActiveModal
		, private editUserService: EditUserService
		, private sec: SecurityService
	) { }

	ngOnInit(): void { this.getPermissions(); }

	getPermissions(): void {
		this.editUserService.getPermissions((model: PermissionVm[]) => (this.permissions = model));
		this.isSysAdmin = this.sec.getSecurity()?.permissionProfile === PermissionProfile.SystemAdmin;
	}
}
